module.exports = __webpack_public_path__ + "img/icon_award-03.2d022638.svg";